<template>
  <SearchAndFilterWrapper
    :search-label="type + ' suchen...'"
    :dialog-title="'Filter ' + type"
    :applied-filters="appliedFilters"
    :apply-filters-fn="applyFilters"
    :reset-pending-fn="resetPending"
    :remove-applied-filter-fn="removeAppliedFilter"
    :clear-all-fn="clearAll"
    @update:search="handleSearch"
  >
    <template v-slot:content>
      <div class="mb-4">
        <div class="text-subtitle-1 mb-2">Tags</div>
        <v-select
          v-model="pending.selectedTags"
          :items="api.tags"
          placeholder="Tags auswählen"
          hide-selected
          hide-details
          no-data-text="Keine Filtermöglichkeiten gefunden"
          multiple
          clearable
          chips
          variant="solo"
          density="comfortable"
        >
          <template v-slot:chip="{ item, index, props }">
            <v-chip
              v-bind="props"
              :key="index"
              closable
              color="secondary"
              size="small"
              variant="flat"
              @click.stop
              @click:close.stop="removePendingTag(item.raw ?? item)"
              class="me-1"
            >
              <span>{{ item?.title }}</span>
            </v-chip>
          </template>
        </v-select>
      </div>
      <div class="mb-4">
        <v-row>
          <v-col cols="12" sm="6">
            <div class="text-subtitle-1 mb-2">Ist buchbar</div>
            <v-select
              v-model="pending.isBookable"
              :items="bookingStatusOptions"
              placeholder="Ist buchbar"
              variant="solo"
              density="comfortable"
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="text-subtitle-1 mb-2">Ist öffentlich</div>
            <v-select
              v-model="pending.isPublic"
              :items="bookingStatusOptions"
              placeholder="Ist öffentlich"
              variant="solo"
              density="comfortable"
              clearable
              hide-details
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <div class="text-subtitle-1 mb-2">Wiederkehrende zulassen</div>
            <v-select
              v-model="pending.allowRecurringBooking"
              :items="bookingStatusOptions"
              placeholder="Wiederkehrende zulassen"
              variant="solo"
              density="comfortable"
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="text-subtitle-1 mb-2">Automatisch freigeben</div>
            <v-select
              v-model="pending.autoCommitBooking"
              :items="bookingStatusOptions"
              placeholder="Automatisch freigeben"
              variant="solo"
              density="comfortable"
              clearable
              hide-details
            ></v-select>
          </v-col>
        </v-row>
      </div>
    </template>
  </SearchAndFilterWrapper>
</template>

<script>
import ApiTagsService from "../../services/api/ApiTagsService";
import SearchAndFilterWrapper from "@/components/Filters/SearchAndFilterWrapper.vue";

export default {
  name: "BookableSearchAndFilter",
  components: { SearchAndFilterWrapper },
  props: { type: String },
  data() {
    return {
      pending: {
        isBookable: null,
        isPublic: null,
        allowRecurringBooking: null,
        autoCommitBooking: null,
        selectedTags: [],
      },
      applied: {},
      bookingStatusOptions: [
        { title: "Ja", value: true },
        { title: "Nein", value: false },
      ],
      api: { tags: [] },
    };
  },
  watch: {
    "$route.query": {
      deep: true,
      handler(newQuery) {
        const filters = this.queryToFilters(newQuery);
        this.applied = JSON.parse(JSON.stringify(filters));
        this.pending = JSON.parse(JSON.stringify(filters));
        this.$emit("update:filters", this.applied);
      },
    },
  },
  computed: {
    appliedFilters() {
      const chips = [];

      if (this.applied.selectedTags)
        this.applied.selectedTags.forEach((tag) => {
          chips.push({ type: "tag", value: tag, label: `Tag: ${tag}` });
        });

      if (this.applied.isBookable !== null)
        chips.push({
          type: "isBookable",
          value: this.applied.isBookable,
          label: `Ist buchbar: ${this.applied.isBookable ? "Ja" : "Nein"}`,
        });

      if (this.applied.isPublic !== null)
        chips.push({
          type: "isPublic",
          value: this.applied.isPublic,
          label: `Ist öffentlich: ${this.applied.isPublic ? "Ja" : "Nein"}`,
        });

      if (this.applied.allowRecurringBooking !== null)
        chips.push({
          type: "allowRecurringBooking",
          value: this.applied.allowRecurringBooking,
          label: `Wiederkehrende zulassen: ${
            this.applied.allowRecurringBooking ? "Ja" : "Nein"
          }`,
        });

      if (this.applied.autoCommitBooking !== null)
        chips.push({
          type: "autoCommitBooking",
          value: this.applied.autoCommitBooking,
          label: `Automatisch freigeben: ${
            this.applied.autoCommitBooking ? "Ja" : "Nein"
          }`,
        });

      return chips;
    },
  },
  methods: {
    fetchFilterTags() {
      ApiTagsService.getTags()
        .then((response) => (this.api.tags = response.data))
        .catch((error) => console.log(error));
    },
    removePendingTag(tag) {
      this.pending.selectedTags = this.pending.selectedTags.filter(
        (t) => t !== tag
      );
    },
    removeAppliedFilter(chip) {
      if (chip.type === "tag")
        this.applied.selectedTags = this.applied.selectedTags.filter(
          (t) => t !== chip.value
        );
      else this.applied[chip.type] = null;

      this.$emit("update:filters", this.applied);
      this.updateUrlFromFilters(this.applied);
    },
    applyFilters() {
      this.applied = JSON.parse(JSON.stringify(this.pending));
      this.$emit("update:filters", this.applied);
      this.updateUrlFromFilters(this.applied);
    },
    clearAll() {
      this.pending = {
        isBookable: null,
        isPublic: null,
        allowRecurringBooking: null,
        autoCommitBooking: null,
        selectedTags: [],
      };
      this.applied = JSON.parse(JSON.stringify(this.pending));
      this.$emit("update:filters", this.applied);
      this.updateUrlFromFilters(this.applied);
    },
    resetPending() {
      this.pending = JSON.parse(JSON.stringify(this.applied));
    },
    filtersToQuery(filters) {
      const query = {};

      if (filters.isBookable !== null) query.isBookable = filters.isBookable;
      if (filters.isPublic !== null) query.isPublic = filters.isPublic;
      if (filters.allowRecurringBooking !== null)
        query.allowRecurringBooking = filters.allowRecurringBooking;
      if (filters.autoCommitBooking !== null)
        query.autoCommitBooking = filters.autoCommitBooking;
      if (filters.selectedTags && filters.selectedTags.length > 0)
        query.tags = filters.selectedTags.join(",");

      return query;
    },
    queryToFilters(query) {
      return {
        isBookable:
          query.isBookable === "true"
            ? true
            : query.isBookable === "false"
            ? false
            : null,
        isPublic:
          query.isPublic === "true"
            ? true
            : query.isPublic === "false"
            ? false
            : null,
        allowRecurringBooking:
          query.allowRecurringBooking === "true"
            ? true
            : query.allowRecurringBooking === "false"
            ? false
            : null,
        autoCommitBooking:
          query.autoCommitBooking === "true"
            ? true
            : query.autoCommitBooking === "false"
            ? false
            : null,
        selectedTags: query.tags ? query.tags.split(",") : [],
      };
    },
    updateUrlFromFilters(filters) {
      const query = this.filtersToQuery(filters);
      this.$router.replace({ query });
    },
    handleSearch(value) {
      this.$emit("update:search", value);
    },
  },
  mounted() {
    this.fetchFilterTags();

    const initialFilters = this.queryToFilters(this.$route.query);
    this.applied = JSON.parse(JSON.stringify(initialFilters));
    this.pending = JSON.parse(JSON.stringify(initialFilters));
    this.$emit("update:filters", this.applied);
  },
};
</script>

<style scoped lang="scss">
::v-deep .active-button {
  color: white !important;
  background-color: #0099db !important;
}
</style>
